// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 625 ? "3089ca91" : chunkId) + "." + {"625":"0dc9e27725717dfd","789":"a1494213be467c19","862":"21dc8f136e8c5a94"}[chunkId] + ".js";
};